export const ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOADING: 'LOADING',
  GET_PRODUCTS: 'GET_PRODUCTS',
}

export const ROUTES = {
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  NEW_PASSWORD: '/new-password',
  MAIL: '/mail',
  ORDERS: '/orders',
  ORDERS_TRACKING: '/orders-tracking',
  PRODUCTS: '/products',
  ADD_PRODUCT: '/add-product',
  SITES: '/sites',
  BALANCE: '/balance',
  NEWS: '/news',
  NEWS_LETTER: '/news-letter',
  USERS: '/users',
  ROLES: '/roles',
  SELLER_TRANSACTION: '/seller-transaction',
  SUPPLIER_TRANSACTION: '/supplier-transaction',
  PRODUCT_TYPES: '/product-types',
  SETTING_APP: '/setting-app',
  SETTING_CATEGORIES: '/setting-categories',
  SETTING_CARRIES: '/setting-carries',
  SETTING_SELLER_LEVELS: '/setting-seller-levels',
  SETTING_NEWS: '/setting-news',
  SETTING_CONTENT: '/setting-content',
  ORDERS_TRACKING_DETAIL: '/order-detail',
  TRACKING_LOG: '/tracking-log',
  PROFILE: '/profile',
  INSTALL: '/install',
  INSTALL_APP_AMAZON: '/install_amazon',
  LOGS: '/logs',
  ORDER_ARCHIVE: '/order-archive',
  AUTH: '/auth',
  VERIFY_APP_AMAZON: '/amazon',
  PRIVACY: '/privacy',
  // Resolution System
  ACCOUNT_SETTING: '/account-setting',
  DISPUTES: '/disputes',
  // Helpdesk (Phase 06)
  HELPDESK_INBOX: '/support/inbox',
  HELPDESK_TICKET: '/support/ticket/:ticket_id',
  HELPDESK_SLA_SETTINGS: '/support/settings/sla',
  HELPDESK_STORE_SETTINGS: '/support/settings/stores',
  HELPDESK_DNS_GUIDE: '/support/settings/dns-guide',
  HELPDESK_CANNED_REPLIES: '/support/settings/canned-replies',
  HELPDESK_BLOCKED_SENDERS: '/support/settings/blocked-senders',
  // Research / FB Ads Library
  RESEARCH_FB_ADS: '/research/fb-ads',
  RESEARCH_FB_ADS_SETTINGS: '/research/fb-ads/settings',
  // Analytics
  ANALYTICS: '/analytics',
  // Amazon Bulk Ads
  AMAZON_BULK_ADS: '/amazon-bulk-ads',
  // Amazon Ads
  AMAZON_ADS: '/amazon-ads',
  // GA4 Site Analytics (per phase-03)
  SITE_ANALYTICS: '/site-analytics',
  // Amazon Ads Automation Rules
  AMAZON_ADS_AUTOMATION_RULES: '/amazon-ads-automation-rules',
  // SKU Mapping
  SKU_MAPPING: '/sku-mapping',
  // Order Invoice
  ORDER_INVOICE: '/order-invoice',
  ORDER_INVOICE_SOURCES: '/order-invoice/sources',
  // Money Flow
  MONEY_FLOW: '/money-flow',
  MONEY_FLOW_SUPPLIERS: '/money-flow/suppliers',
  MONEY_FLOW_PAYMENTS: '/money-flow/payments',
  MONEY_FLOW_MONTHLY_REPORT: '/money-flow/monthly-report',
  // Amazon Disbursements
  AMAZON_DISBURSEMENTS: '/money-flow/amazon-disbursements',
  // Inventory
  INVENTORY_LISTING: '/inventory/listing',
  INVENTORY_LISTING_QUEUE: '/inventory/listing-queue',
  INVENTORY_LISTING_QUEUE_DETAIL: '/inventory/listing-queue/:id',
  INVENTORY_AMZ_PRODUCT_TYPES: '/inventory/amz-product-types',
  INVENTORY_AMZ_PRODUCT_TYPE_DETAIL: '/inventory/amz-product-types/:id',
  INVENTORY_FBA_SHIPMENTS: '/inventory/fba-shipments',
  INVENTORY_PURCHASE_ORDERS: '/inventory/purchase-orders',
  INVENTORY_PURCHASE_ORDER_DETAIL: '/inventory/purchase-orders/:id',
  INVENTORY_PURCHASE_ORDER_CREATE: '/inventory/purchase-orders/create',
  INVENTORY_PURCHASE_ORDER_EDIT: '/inventory/purchase-orders/:id/edit',
  // PO Settings
  SETTING_PO: '/settings/po',
  // Fulfillment Settings
  SETTING_FULFILLMENTS: '/settings/fulfillments',
  // Amazon Keywords Library
  AMAZON_KEYWORDS: '/amazon-keywords',
  // Marketing / Ads Command Center (phase-02+)
  MARKETING: '/marketing',
  MARKETING_SETTINGS: '/marketing/settings',
  MARKETING_SETUP_GUIDE: '/marketing/setup-guide',
  MARKETING_SOLD_PRODUCTS: '/marketing/sold-products',
}

export const STATUS_ORDER = {
  PENDING_DESIGN: 'pending-design',
  NEED_PAY: 'need-pay',
  PENDING: 'pending',
  IN_PRODUCTION: 'in-production',
  SHIPPED: 'shipped',
  CANCELLED_REFUNDED: 'cancelled-refunded',
  ON_HOLD: 'on-hold',
  ACTION_REQUIRED: 'action-required',
  ARCHIVED: 'archived',
}

export const PERMISSIONS = {
  view_dashboard: 'view_dashboard',
  view_order: 'view_order',
  repair_order: 'repair_order',
  view_tracking_order: 'view_tracking_order',
  update_status_order: 'update_status_order',
  update_design_order: 'update_design_order',
  cancel_product_in_order: 'cancel_product_in_order',
  approve_product_in_order: 'approve_product_in_order',
  rebuild_product_in_order: 'rebuild_product_in_order',
  update_product_in_order: 'update_product_in_order',
  view_news: 'view_news',
  update_news: 'update_news',
  create_news: 'create_news',
  view_product: 'view_product',
  create_product: 'create_product',
  update_product: 'update_product',
  delete_product: 'delete_product',
  view_product_type: 'view_product_type',
  create_product_type: 'create_product_type',
  edit_product_type: 'edit_product_type',
  delete_product_type: 'delete_product_type',
  duplicate_product_type: 'duplicate_product_type',
  update_active_product_type: 'update_active_product_type',
  view_app_setting: 'view_app_setting',
  view_user_management: 'view_user_management',
  view_tracking_log: 'view_tracking_log',
  setting: 'setting',
  view_logs_app: 'view_logs_app',
  view_sites: 'view_sites',
  view_category: 'view_category',
  create_category: 'create_category',
  edit_category: 'edit_category',
  remove_category: 'remove_category',
  view_carrier: 'view_carrier',
  create_carrier: 'create_carrier',
  edit_carrier: 'edit_carrier',
  update_active_carrier: 'update_active_carrier',
  view_content_setting: 'view_content_setting',
  view_seller_level: 'view_seller_level',
  create_level: 'create_level',
  edit_shipping_info: 'edit_shipping_info',
  assign_supplier_order: 'assign_supplier_order',
  assign_producttype_order: 'assign_producttype_order',
  import_tracking_number: 'import_tracking_number',
  import_orders: 'import_orders',
  add_site: 'add_site',
  edit_site: 'edit_site',
  remove_site: 'remove_site',
  assign_seller_site: 'assign_seller_site',
  assign_view_order: 'assign_view_order',
  edit_access_file_design: 'edit_access_file_design',
  update_active_site: 'update_active_site',
  create_new_user: 'create_new_user',
  edit_user: 'edit_user',
  remove_user: 'remove_user',
  view_order_archive: 'view_order_archive',
  add_file_design: 'add_file_design',
  view_dispute: 'view_dispute',
  view_account_setting: 'view_account_setting',
  add_pay_gate: 'add_pay_gate',
  update_pay_gate: 'update_pay_gate',
  delete_pay_gate: 'delete_pay_gate',
  view_product_feed: 'view_product_feed',
  view_collection: 'view_collection',
  // SKU Mapping
  view_sku_mapping: 'view_sku_mapping',
  create_sku_mapping: 'create_sku_mapping',
  edit_sku_mapping: 'edit_sku_mapping',
  delete_sku_mapping: 'delete_sku_mapping',
  approve_sku_mapping: 'approve_sku_mapping',
  calculate_cogs: 'calculate_cogs',
  // Analytics
  view_analytics: 'view_analytics',
  manage_analytics: 'manage_analytics',
  // Ads
  view_ads: 'view_ads',
  manage_ads: 'manage_ads',
  // Order Invoice
  view_order_invoice: 'view_order_invoice',
  manage_order_invoice: 'manage_order_invoice',
  view_invoice_templates: 'view_invoice_templates',
  manage_invoice_templates: 'manage_invoice_templates',
  // Money Flow
  view_money_flow: 'view_money_flow',
  manage_money_flow: 'manage_money_flow',
  view_suppliers_payment: 'view_suppliers_payment',
  manage_suppliers_payment: 'manage_suppliers_payment',
  view_monthly_report: 'view_monthly_report',
  // Amazon Disbursements
  view_amazon_disbursements: 'view_amazon_disbursements',
  sync_amazon_disbursements: 'sync_amazon_disbursements',
  // Inventory
  view_inventory: 'view_inventory',
  // Listings
  view_listings: 'view_listings',
  edit_listings: 'edit_listings',
  manage_listing_timeline: 'manage_listing_timeline',
  // Purchase Orders
  view_purchase_order: 'view_purchase_order',
  edit_purchase_order: 'edit_purchase_order',
  // Amazon Keywords Library
  view_keywords: 'view_keywords',
  manage_keywords: 'manage_keywords',
  // Amazon Ads Automation Rules
  view_automation_rules: 'view_automation_rules',
  manage_automation_rules: 'manage_automation_rules',
  // Fulfillment Integration
  view_fulfillment: 'view_fulfillment',
  manage_fulfillment: 'manage_fulfillment',
  // Helpdesk
  view_helpdesk_inbox: 'view_helpdesk_inbox',
  view_helpdesk_ticket: 'view_helpdesk_ticket',
  reply_helpdesk_ticket: 'reply_helpdesk_ticket',
  update_helpdesk_status: 'update_helpdesk_status',
  assign_helpdesk_ticket: 'assign_helpdesk_ticket',
  view_internal_notes: 'view_internal_notes',
  add_internal_notes: 'add_internal_notes',
  view_ai_draft: 'view_ai_draft',
  regenerate_ai_draft: 'regenerate_ai_draft',
  manage_helpdesk_settings: 'manage_helpdesk_settings',
  manage_helpdesk_stores: 'manage_helpdesk_stores',
  view_canned_replies: 'view_canned_replies',
  manage_canned_replies: 'manage_canned_replies',
  archive_helpdesk_ticket: 'archive_helpdesk_ticket',
  mark_helpdesk_spam: 'mark_helpdesk_spam',
  delete_helpdesk_ticket: 'delete_helpdesk_ticket',
  // Research / FB Ads Library
  research_fb_ads_search: 'research:fb_ads:search',
  research_fb_ads_save: 'research:fb_ads:save',
  research_fb_ads_export: 'research:fb_ads:export',
  research_fb_ads_manage_folders: 'research:fb_ads:manage_folders',
  research_fb_ads_manage_config: 'research:fb_ads:manage_config',
  // Marketing / Ads Command Center (phase-02+)
  fb_marketing_view: 'fb_marketing_view',
  fb_marketing_manage: 'fb_marketing_manage',
}

export const IMAGE_DEFAULT =
  'https://s3.ap-northeast-1.wasabisys.com/ecom-fulfill/2021/09/12/8f70ac1d-4070-46cb-9ed9-577cd38d7f3c_noimage.jpg'

// Do scripts/bump-version.js nhúng vào lúc build (patch tự tăng mỗi lần deploy).
// Fallback chỉ dùng khi chạy dev chưa qua build.
export const VERSION_APP = process.env.REACT_APP_VERSION || 'dev'
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || ''

export const DATA_VARIANT = {
  DATA_VARIANT: 'DATA_VARIANT',
}
export const DATA_PRINT_FILE = {
  DATA_PRINT_FILE: 'DATA_PRINT_FILE',
}
export const CREATE_NEWS = {
  CREATE_NEWS: 'CREATE_NEWS',
}

export const NEWS_WATCHED = {
  NEWS_WATCHED: 'NEWS_WATCHED',
}

export const SEND_USERS = {
  SEND_USERS: 'SEND_USERS',
}

export const ORDERS_SOCKET = {
  ORDERS_SOCKET: 'ORDERS_SOCKET',
}
export const ORDERS_API = {
  ORDERS_API: 'ORDERS_SOCKET',
}
export const NEWS_SOCKET = {
  NEWS_SOCKET: 'NEWS_SOCKET',
}
export const NEWS_API = {
  NEWS_API: 'NEWS_SOCKET',
}
export const NEWS_API_IS_SEEN = {
  NEWS_API_IS_SEEN: 'NEWS_API_IS_SEEN',
}
export const NEWS_API_IS_SEEN_ACTION = {
  NEWS_API_IS_SEEN_ACTION: 'NEWS_API_IS_SEEN_ACTION',
}

export const SEARCH_NEWS = {
  SEARCH_NEWS: 'SEARCH_NEWS',
}
